import {AnalyticEventProps} from '@/types';

export const productAnalyticProps: AnalyticEventProps = {
	eventCategory: 'card',
	interactionType: 'click',
	eventAction: 'navigation',
	eventLabel: 'EGS Product Page',
	eventValue: {
		component: 'SpendStep',
		section: 'products',
		subView: 'Spend Balance',
		interactedElement: 'Product Title'
	}
};
